import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteShift, editShift, getShift, getShiftDetail } from './thunk';

export const initialState = {
  search: '',
  shifts: [] as any[],
  shiftDetail: null,
  shiftList: [] as any[],
  currentShift: null as any,
  currentShiftDetail: null as any,
  error: null as string | null,
};

const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setShiftList: (state, action: PayloadAction<any>) => {
      state.shiftList = action.payload;
    },
    selectShift: (state, action: PayloadAction<any>) => {
      state.currentShift = action.payload;
    },
    updateShift: (state, action: PayloadAction<any>) => {
      const updated = action.payload;
      if (state.currentShift && state.currentShift.id === updated.id) {
        state.currentShift = updated;
      }
      if (state.currentShiftDetail && state.currentShiftDetail.id === updated.id) {
        state.currentShiftDetail = updated;
      }
    },
    setCurrentShiftDetail: (state, action: PayloadAction<any>) => {
      state.currentShiftDetail = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getShift.fulfilled, (state, action: any) => {
      state.shifts = action.payload;
    });
    builder.addCase(getShiftDetail.fulfilled, (state, action: any) => {
      state.shiftDetail = action.payload;
      state.currentShiftDetail = action.payload;

      if (action.payload?.id) {
        state.currentShift = action.payload;
      }
    });
    builder.addCase(editShift.fulfilled, (state, action: any) => {
      const updated = action.payload;
      state.shifts = state.shifts.map((shift: any) => (shift.id === updated.id ? updated : shift));
      state.shiftList = state.shiftList.map((shift: any) =>
        shift.id === updated.id ? updated : shift,
      );

      if (state.currentShift?.id === updated.id) {
        state.currentShift = updated;
      }

      if (state.currentShiftDetail?.id === updated.id) {
        state.currentShiftDetail = updated;
      }
    });
    builder.addCase(deleteShift.fulfilled, (state, action) => {
      const shiftId = action.meta.arg;
      state.shifts = state.shifts.filter((shift: any) => shift.id !== shiftId);
      state.shiftList = state.shiftList.filter((shift: any) => shift.id !== shiftId);

      if (state.currentShift?.id === shiftId) {
        state.currentShift = null;
      }

      if (state.currentShiftDetail?.id === shiftId) {
        state.currentShiftDetail = null;
      }
    });
    // builder.addCase(fetchShiftDetail.pending, (state) => {
    //   state.error = null;
    // });
    // builder.addCase(fetchShiftDetail.fulfilled, (state, action: any) => {
    //   state.currentShiftDetail = action.payload;
    // });
    // builder.addCase(fetchShiftDetail.rejected, (state, action: any) => {
    //   state.error = action.error.message || 'Failed to fetch shift detail';
    // });
  },
});

export const {
  updateSearch,
  setShiftList,
  selectShift,
  updateShift,
  setCurrentShiftDetail,
  setError,
} = shiftSlice.actions;

export default shiftSlice.reducer;
